<!-- 体验用户  -->
<template>
  <div style="margin-top: 20px;">
    <div class="box-card" style="text-align: left">
      <!-- 查询表单 -->
      <el-form :inline="true" size="small" label-position="right" class="query_form" :model="queryForm"
        @submit.native.prevent>
        <el-form-item label="手机号：">
          <el-input maxlength="11" placeholder="请输入手机号" v-model="queryForm.phone"
            @input="(e) => (queryForm.phone = validSpace(e))" @keyup.enter.native="onSubmit"></el-input>
        </el-form-item>
        <el-form-item label="公司名称：">
          <el-input placeholder="请输入公司名称" v-model="queryForm.company"
            @input="(e) => (queryForm.company = validSpecialChar(e))" @keyup.enter.native="onSubmit"></el-input>
        </el-form-item>
        <el-form-item label="负责人：">
          <el-input maxlength="10" placeholder="请输入姓名" v-model="queryForm.principal"
            @input="(e) => (queryForm.principal = validSpecialChar(e))" @keyup.enter.native="onSubmit"></el-input>
        </el-form-item>
        <el-form-item>
          <lbButton icon="chaxun" :fill="true" @click=" onSubmit()">查询</lbButton>
        </el-form-item>
      </el-form>
      <le-card title="体验用户">
        <template slot="heard-right">
        <div class="right">
            <lbButton type="err" icon="shanchu1" @click="batchDel" v-if="isShowBtn('5490175b5d464941826f7119')">删除
            </lbButton>
            <lbButton icon="xinzeng" @click="addExperience()" v-if="isShowBtn('5490175b5d464941826f7118')">新增
            </lbButton>
          </div>
          </template>
        <!-- 主要内容 -->
        <div>
          <!-- 表格 -->
          <!-- 使用插件生产表格 -->
          <!-- <avue-crud :data="tableData" :option="option" :page.sync="page" @size-change="sizeChange"
            @selection-change="selectionChange" @current-change="currentChange">
            <template slot-scope="{row}" slot="create_time">
              {{ $moment( row.create_time).format("YYYY-MM-DD HH:mm:ss") }}
            </template>
            <template slot-scope="{row}" slot="menu">
              <lbButton type="warning" icon="bianji" hint="编辑" @click=" editExperience(row)" v-if="isShowBtn('5490175b5d464941826f7111')"></lbButton>
            </template>
          </avue-crud> -->
          <el-table class="tablestyle" ref="multipleTable" :data="tableData" align="center" header-align="center"
          tooltip-effect="dark" border stripe @selection-change="selectionChange">
          <el-table-column type="selection" width="50" align="center" header-align="center"></el-table-column>
          <el-table-column  prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="company" label="公司名称"></el-table-column>
          <el-table-column prop="principal" label="负责人"></el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              {{ $moment( scope.row.create_time).format("YYYY-MM-DD HH:mm:ss") }}
              </template>
          </el-table-column>

          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <lbButton type="warning" icon="bianji" hint="编辑" @click=" editExperience(scope.row)" v-if="isShowBtn('5490175b5d464941826f7111')"></lbButton>
            </template>
          </el-table-column>
        </el-table>
         <!-- 页码 -->
         <el-pagination @size-change="sizeChange" @current-change="currentChange"
          :current-page="queryForm.PageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="queryForm.PageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="page.total"></el-pagination>
        </div>
      </le-card>
    </div>
    <!-- 新增编辑体验用户 -->
    <lebo-dialog append-to-body :title="dialogExperienceUsersId ? '编辑体验用户' : '新增体验用户'" :isShow="showAddexperienceUsers"
      width="35%" @close="showAddexperienceUsers = false" footerSlot>
      <addexperienceUsers @closeDialog="closeexperienceUsers" v-if="showAddexperienceUsers" :id="dialogExperienceUsersId"></addexperienceUsers>
    </lebo-dialog>
  </div>
</template>

<script>
import addexperienceUsers from './components/addexperienceUsers/indx.vue'
import { getAIAccountInfoList, deletAIAccount } from '@/api/maintenanceCenter'
export default {
  name: 'experienceUsers',
  components: { addexperienceUsers },
  props: {},
  data () {
    return {
      // 查询表单
      queryForm: {
        principal: '', // 负责人
        phone: '', // 手机号
        company: '', // 公司
        PageSize: 10,
        PageIndex: 1
      },
      showAddexperienceUsers: false, // 新增编辑体验用户
      dialogExperienceUsersId: '', // 弹框体验用户id
      // 表格数据
      tableData: [],
      // 选中的表格数据
      multipleSelection: [],
      // 表格插件配置项
      option: {
        searchMenuSpan: 8,
        header: false,
        delBtn: false, // 行删除按钮
        editBtn: false, // 编辑按钮
        selection: true,
        selectionFixed: false, // 解除选择框冻结
        menuAlign: 'left', // 属性对齐方式
        menuHeaderAlign: 'left', // 表头对齐方式
        menu: true,
        menuFixed: false, // 解除操作框冻结
        tip: false,
        column: [
          {
            label: '手机号',
            prop: 'phone'
          }, {
            label: '公司名称',
            prop: 'company'
          }, {
            label: '负责人',
            prop: 'principal'
          }, {
            label: '创建时间',
            prop: 'create_time',
            slot: true
          }
        ]
      },
      // 分页器
      page: {
        background: false,
        total: 0,
        pageSize: 10,
        currentPage: 1
      }
    }
  },
  watch: {},
  computed: {},
  methods: {
    // 获取体验用户列表
    async fnGetAIAccountInfoList () {
      const res = await getAIAccountInfoList(this.queryForm)
      console.log('res', res)
      this.tableData = res.Data.DataList
      this.page.total = res && res.Code === 200 && res.Data ? res.Data.TotalCount : 0
    },
    // 查询
    onSubmit () {
      this.queryForm.PageIndex = 1
      this.fnGetAIAccountInfoList()
    },
    // 每页条数改变
    sizeChange (val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      this.queryForm.PageSize = val
      this.fnGetAIAccountInfoList()
    },
    // 页码改变
    currentChange (val) {
      this.queryForm.PageIndex = val
      this.page.currentPage = val
      this.fnGetAIAccountInfoList()
      this.$refs.multipleTable.bodyWrapper.scrollTop = 0
    },
    // 选中的数据
    selectionChange (list) {
      this.multipleSelection = list
    },
    // 关闭弹框
    closeexperienceUsers () {
      this.showAddexperienceUsers = false
      this.fnGetAIAccountInfoList()
    },
    // 新增用户
    addExperience () {
      this.dialogExperienceUsersId = ''
      this.showAddexperienceUsers = true
    },
    // 编辑用户
    editExperience (row) {
      this.dialogExperienceUsersId = row._id
      this.showAddexperienceUsers = true
    },
    // 批量删除
    batchDel () {
      if (this.multipleSelection.length > 0) {
        this.$confirm('此操作将永久删除选中的用户, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var obj = {}
          var arr = []
          for (var i = 0; i < this.multipleSelection.length; i++) {
            arr.push(this.multipleSelection[i]._id)
            if (arr.length === this.multipleSelection.length) {
              this.fnDeleteAIcounters(arr)
            }
          }
        }).catch(() => {
          this.$msg.info('已取消删除')
        })
      } else {
        this.$msg.warning('请选择要删除的用户！')
      }
    },
    async fnDeleteAIcounters (arr) {
      const res = await deletAIAccount(arr)
      if (res && res.Code === 200) {
        this.$msg.success(res.Message)
      }
      this.fnGetAIAccountInfoList()
    }
  },
  created () { },
  mounted () {
    this.fnGetAIAccountInfoList()
  }
}
</script>

<style scoped></style>
